import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useSelector } from 'store';

// project imports
import NavItem from '../NavItem';
import { NavGroupProps } from '../NavGroup';
import useConfig from 'hooks/useConfig';

// assets
import { IconChevronDown, IconChevronUp } from '@tabler/icons';
import useAuth from 'hooks/useAuth';

// ==============================|| SIDEBAR MENU LIST COLLAPSE ITEMS ||============================== //

interface NavCollapseProps {
    menu: NavGroupProps['item'];
    level: number;
}

const NavCollapse = ({ menu, level }: NavCollapseProps) => {
    const theme = useTheme();
    const { user } = useAuth();
    const { borderRadius } = useConfig();

    const [open, setOpen] = useState(false);
    // const [selected, setSelected] = useState<string | null | undefined>(null);
    const { openItem } = useSelector((state) => state.menu);

    const handleClick = () => {
        setOpen(!open);
       // setSelected(!selected ? menu.id : null);
    };

    const { pathname } = useLocation();

    useEffect(() => {
        const childrens = menu.children ? menu.children : [];
        childrens.forEach((item: any) => {
            if (pathname && pathname.includes('product-details')) {
                if (item.url && item.url.includes('product-details')) {
                    setOpen(true);
                }
            }
            if (item.url === pathname) {
                setOpen(true);
            }
        });
    }, [pathname, menu.children]);

    const filterAllowedMenus = (curr_menu:any) => {
        if(curr_menu.developerOnly){
            if(!user || !user.isDeveloper){
                return false;
            }
        }
        if(curr_menu.systemAdminOnly){
            if(!user || !user.isSystemAdmin){
                return false;
            }
        }
        if(curr_menu.hideFromPermission != undefined){
            if(user && user.permissions) {
                const has_hide_permissions = user.permissions.some((permission) => curr_menu.hideFromPermission.includes(permission));
                if(has_hide_permissions) {
                    return false;
                }
            }
        }

        if(curr_menu.requeredPermission != undefined){
            if(!user || !user.permissions){ 
                return false;
            }
            const has_permissions = user.permissions.some((permission) => curr_menu.requeredPermission.includes(permission));
            if(!has_permissions){
                return false;
            }
        }
        if(curr_menu.feature != undefined){
             if(!user || !user.features?.includes(curr_menu.feature)){
                return false;
            }
        }
        
        return true;
    } 
    // menu collapse & item
    const menus = menu.children?.filter(filterAllowedMenus).map((item) => {
        switch (item.type) {
            case 'collapse':
                return <NavCollapse key={item.id} menu={item} level={level + 1} />;
            case 'item':
                return <NavItem key={item.id} item={item} level={level + 1} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    
    const Icon = menu.icon!;
    const menuIcon = menu.icon ? (
        <Icon strokeWidth={1.5} size="1.3rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width: open ? 8 : 6,
                height: open ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    const isMenuSelected = () => {
        if(open){
            return open;
        }
        for(let i = 0; i < openItem.length; i+=1){
            const open_itm =openItem[i];
            const child_selected = menu.children?.find(c=>c.id == open_itm);
            if(child_selected){
                return true;
            }
        }
     
   // const is_selected = selected === menuId;

    // add more logic here
    return false;
};

    return (
        <>
            <ListItemButton 
                sx={{
                    borderRadius: `${borderRadius}px`,
                    mb: 0.5,
                    alignItems: 'flex-start',
                    backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                    py: level > 1 ? 1 : 1.25,
                    pl: `${level * 24}px`
                }}
                selected={isMenuSelected()}
                onClick={handleClick}
            >
                <ListItemIcon sx={{ my: 'auto', minWidth: !menu.icon ? 18 : 36 }}>{menuIcon}</ListItemIcon>
                <ListItemText
                    primary={
                        <Typography variant={open ? 'h5' : 'body1'} color="inherit" sx={{ my: 'auto' }} >
                            {menu.title}
                        </Typography>
                    }
                    secondary={
                        menu.caption && (
                            <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                {menu.caption}
                            </Typography>
                        )
                    }
                />
                {open ? (
                    <IconChevronUp stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                ) : (
                    <IconChevronDown stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                )}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                {open && (
                    <List
                        component="div"
                        disablePadding
                        sx={{
                            position: 'relative',
                            '&:after': {
                                content: "''",
                                position: 'absolute',
                                left: '32px',
                                top: 0,
                                height: '100%',
                                width: '1px',
                                opacity: theme.palette.mode === 'dark' ? 0.2 : 1,
                                background: theme.palette.mode === 'dark' ? theme.palette.dark.light : theme.palette.primary.light
                            }
                        }}
                    >
                        {menus}
                    </List>
                )}
            </Collapse>
        </>
    );
};

export default NavCollapse;
